import React, { useContext, useState } from 'react';
import { Context } from '@front10/helpers/dist/Context';
import { ThemeProvider } from '@front10/base-elements';
import { EmotionCache } from '../../containers/_commons/emotionCache';

/**
 * Atoms
 */
import { FilterButton } from '../../lab/FilterButton';
import { Panels } from '../../containers/VerticalBookingContainer/Panels';
import { FlexibleFilterContainer } from '../../lab/FlexibleFilterContainer';
/**
 * Controls
 */
import TripDuration from '../TripDuration';

const TripDurationFilter = (props, ref) => {
  const {
    onChange,
    value,
    defaultValue = {},
    tripDurationRangeValues,
    disabled,
    filterButtonIconProps,
    doneButtonLabelKey = 'cmp-trip-duration-filter-done-button',
    clearButtonLabelKey = 'cmp-trip-duration-filter-clear-button',
    titleKey = 'cmp-filter-trip-duration-title',
    popover = {}
  } = props;

  const [tripDurationValue, setTripDurationValue] = useState(defaultValue);
  const tripDurationRef = React.useRef();
  const flexibleRef = React.useRef();
  const {
    translate,
    direction,
    theme: { designTokens }
  } = useContext(Context);

  const equals = (object, object1) => {
    return JSON.stringify(object) === JSON.stringify(object1);
  };

  const update = React.useCallback(() => {
    return setTripDurationValue(Boolean(value) ? value : defaultValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const save = () => {
    onChange(tripDurationValue);
  };

  const disabledButton = React.useMemo(() => {
    let disabled = true;
    disabled = !Boolean(value)
      ? equals(tripDurationValue, props.defaultValue) && disabled
      : equals(value, props.defaultValue) && equals(tripDurationValue, props.defaultValue)
      ? disabled
      : false;
    return disabled;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, tripDurationValue]);

  React.useEffect(() => {
    update();
  }, [value, update]);

  const labels = React.useMemo(() => {
    const lookup = {};
    for (let item of props.tripDurationRangeValues) {
      lookup[JSON.stringify(item.value)] = item.name;
    }
    return lookup;
  }, [props.tripDurationRangeValues]);

  var timer;
  return (
    <EmotionCache direction={direction}>
      <ThemeProvider theme={designTokens}>
        <FlexibleFilterContainer
          ref={flexibleRef}
          showSeparator
          saveOnClose={false}
          variant="layout.popover"
          label={translate(titleKey, 'Number of nights')}
          title={translate(titleKey, 'Number of nights')}
          disabledClearButton={disabledButton}
          disabledDoneButton={disabledButton}
          enabledDoneButton
          enabledClearButton
          labelBottomBtn={translate(doneButtonLabelKey, 'Done')}
          labelClearBtn={translate(clearButtonLabelKey, 'Clear')}
          onClearBtn={() => {
            onChange(null);
            setTripDurationValue({});
          }}
          onDismiss={() => {
            update();
          }}
          onOpenPopup={() => {
            setTimeout(() => tripDurationRef.current?.focusToggleElement(), 100);
            update();
          }}
          toggleElement={
            <FilterButton
              iconSettings={filterButtonIconProps}
              value={
                value && !equals(value, props.defaultValue)
                  ? translate(labels[JSON.stringify(value)], 'Number of nights')
                  : translate(titleKey, 'Number of nights')
              }
              active={!!value && !equals(value, props.defaultValue)}
              disabled={disabled} // used to disabled the component
              onFocus={() => {
                if (flexibleRef.current.isOpen) {
                  timer = setTimeout(() => {
                    flexibleRef.current.close();
                  }, 150);
                }
              }}
              onBlur={() => {
                clearTimeout(timer);
              }}
            />
          }
          onSave={() => save()}
          {...popover}
        >
          <Panels showSeparator={false}>
            <TripDuration
              ref={tripDurationRef}
              tripDurationRangeValues={tripDurationRangeValues}
              value={tripDurationValue}
              onChange={(e) => {
                setTripDurationValue(e);
              }}
            />
          </Panels>
        </FlexibleFilterContainer>
      </ThemeProvider>
    </EmotionCache>
  );
};

export default React.forwardRef(TripDurationFilter);
